import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "status-and-time" }
const _hoisted_2 = { class: "order-source-type" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_4 = { class: "remarks-icon-divider" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1)
const _hoisted_6 = { class: "remarks-icon-divider" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StatusIcon = _resolveComponent("StatusIcon")!
  const _component_IconBase = _resolveComponent("IconBase")!

  return (_openBlock(), _createElementBlock("div", {
    class: "order-source",
    style: _normalizeStyle({ background: _ctx.background })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_StatusIcon, {
        "order-status": _ctx.order.status,
        "deliverer-id": _ctx.order.deliverer_id,
        style: _normalizeStyle({ filter: _ctx.filter })
      }, null, 8, ["order-status", "deliverer-id", "style"]),
      _createElementVNode("div", {
        class: "order-time",
        style: _normalizeStyle({ filter: _ctx.filter })
      }, _toDisplayString(_ctx.toShortTime(_ctx.order.time_set_start || _ctx.order.time_start || "")), 5)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["icon-and-asap", { 'divider-margin': _ctx.showRemarks || _ctx.showDeliverer }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_IconBase, {
          icon: _ctx.orderSourceType,
          class: "source-type-icon"
        }, null, 8, ["icon"])
      ]),
      (_ctx.order.time === 'asap')
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "order-time",
            style: _normalizeStyle({ filter: _ctx.filter })
          }, _toDisplayString(_ctx.translate("asap")), 5))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.showRemarks)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_IconBase, { icon: "comment" })
          ])
        ], 64))
      : _createCommentVNode("", true),
    (_ctx.showDeliverer)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_IconBase, { icon: "scooter" })
          ])
        ], 64))
      : _createCommentVNode("", true)
  ], 4))
}